// @ts-nocheck
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import getColor from "@insite/mobius/utilities/getColor";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React from "react";
import { css } from "styled-components";

interface BuyingListTableHeadStyles {
    tableHead?: DataTableHeadProps;
    tableHeader?: DataTableHeaderProps;
}
interface BuyingListManagementTableHeadProps {
    buyingListHeaders: (string | JSX.Element)[];
    extendedStyles?: BuyingListTableHeadStyles;
}

const buyingListTableHeadStyles: BuyingListTableHeadStyles = {
    tableHead: {
        css: css`
            background-color: ${getColor("common.checkboxPickerBackground")};
        `,
    },
    tableHeader: {
        css: css`
            background-color: ${getColor("common.checkboxPickerBackground")};
        `,
    },
};

const BuyingListTableHead: React.FC<BuyingListManagementTableHeadProps> = ({ buyingListHeaders, extendedStyles }) => {
    const styles = useExpandProps<BuyingListTableHeadStyles>(buyingListTableHeadStyles, extendedStyles, {});
    return (
        <DataTableHead data-test-selector="buyingListManagement_tableHead" {...styles.tableHead}>
            {buyingListHeaders.map(header => {
                return (
                    <DataTableHeader {...styles.tableHeader} key={header.toString()} {...styles.tableHeader}>
                        {header}
                    </DataTableHeader>
                );
            })}
        </DataTableHead>
    );
};
export default BuyingListTableHead;
